import { useMemo } from "react";

import { PANEL_CONFIGS } from "../components/panelConfigs";
import { mapPanelData } from "../components/panelDataMapper";

const CONTACT_PANEL_LABELS = {
  clientPhoneNumbers: PANEL_CONFIGS.clientPhoneNumbers.contacts.map(
    (_, index) => `Client Phone ${index + 1}`
  ),
  clientEmail: PANEL_CONFIGS.clientEmail.contacts.map((_, index) => `Client Email ${index + 1}`),
  clientAddress1: ["Name", "Address", "City St Zip"],
  clientAddress2: ["Name", "Address", "City St Zip"],
  clientSpouseContact: ["Name", "Address", "City St Zip"],
  clientEmergencyContact: ["Name", "Address", "City St Zip"],
};

export const useClientPanelData = (clientData, formatDate, showContactLabels = false) => {
  return useMemo(() => {
    if (!clientData) return {};

    const panelData = {};

    Object.entries(PANEL_CONFIGS).forEach(([key, config]) => {
      panelData[key] = mapPanelData(
        config,
        clientData,
        formatDate,
        showContactLabels ? CONTACT_PANEL_LABELS[key] : undefined
      );
    });

    return panelData;
  }, [clientData, formatDate, showContactLabels]);
};
